"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_helmet_1 = __importDefault(require("react-helmet"));
const OrderHistoryGrid_1 = __importDefault(require("../../components/OrderHistory/OrderHistoryGrid"));
const errorNotification_1 = require("../../errorNotification");
function useQuery() {
    const { search } = (0, react_router_dom_1.useLocation)();
    return react_1.default.useMemo(() => new URLSearchParams(search), [search]);
}
const Grid = ({ match }, props) => {
    const { orderId } = match.params;
    const query = useQuery();
    let orderIds = [];
    if (orderId === 'aggregate') {
        orderIds = query.getAll('id');
        if (orderIds.length === 0) {
            (0, errorNotification_1.notifyError)('No orders selected!');
        }
    }
    else {
        orderIds = [orderId];
    }
    return (react_1.default.createElement("div", { className: 'container flex flex-col' },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Order History")),
        react_1.default.createElement("div", { className: "md:flex md:items-center md:justify-between my-4" },
            react_1.default.createElement("div", { className: "flex-1 min-w-0 " },
                react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, "Bestellhistorie")),
            react_1.default.createElement("div", { className: "mt-4 flex md:mt-0 md:ml-4" })),
        react_1.default.createElement(OrderHistoryGrid_1.default, { orderIds: orderIds })));
};
exports.default = Grid;
